import { render, staticRenderFns } from "./AccountResourceTable.vue?vue&type=template&id=4d09ce1e&"
import script from "./AccountResourceTable.vue?vue&type=script&lang=js&"
export * from "./AccountResourceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports